import { Component } from "react";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("App error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="s2m-gradient flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <img src="/logo-s2m.png" alt="Science2Movement" className="h-16 w-16 rounded-2xl object-cover" />
          <h1 className="text-2xl font-semibold text-[#1f3a5f]">Si è verificato un errore</h1>
          <p className="max-w-sm text-sm text-muted-foreground">Ricarica la pagina per continuare. Se il problema persiste, scrivi a science2movement@gmail.com.</p>
          <Button onClick={() => window.location.reload()} data-testid="error-reload-button">Ricarica</Button>
        </div>
      );
    }
    return this.props.children;
  }
}
